/* Polsk katalog for locale-closing-purchases-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'route.arsavslutning-kjop': 'Zakupy i dokumenty',
  'clo.purchases.title': 'Zakupy i dokumenty',
  'clo.purchases.year': 'Rok podatkowy {{year}}',
  'clo.purchases.subtitle': 'Sprawdź zakupy i dokumenty za rok podatkowy {{year}}.',
  'clo.purchases.pending': 'Zakupy lub dokumenty do obsłużenia przed gotowością kontroli zakupów za {{year}}: {{count}}.',
  'clo.purchases.ready': 'Nie znaleziono nieobsłużonych zakupów ani brakujących dokumentów zakupu za {{year}}.',
  'clo.purchases.unsupported': 'Kontrola zakupów nie jest obsługiwana dla tego kraju, przepisów lub roku.',
  'clo.purchases.purchaseIssues': 'Zakupy wymagające działania',
  'clo.purchases.missingTitle': 'Transakcje bez dokumentu ({{count}})',
  'clo.purchases.missingSummary': 'Dodaj dokumentację należącą do każdej transakcji.',
  'clo.purchases.reviewMissing': 'Pokaż i dodaj dokumenty',
  'clo.purchases.documentsModalTitle': 'Brakujące dokumenty',
  'clo.purchases.missingHelp': 'Przeciągnij dokument na właściwą linię lub go prześlij.',
  'clo.purchases.missingDateAction': 'Brak prawidłowej daty – otwórz transakcję, aby wybrać rok',
  'clo.purchases.upload': 'Prześlij dokument',
  'clo.purchases.uploading': 'Przesyłanie …',
  'clo.purchases.uploaded': 'Dokument został dodany.',
  'clo.purchases.uploadLater': 'Dodaj dokumenty później',
  'clo.purchases.uploadError': 'Nie udało się przesłać dokumentu.',
  'clo.purchases.noMissingDocumentation': 'Wszystkie transakcje mają dokumenty.',
  'clo.purchases.deferredHelp': 'Dokumenty zostaną przesłane później. Możesz kontynuować przegląd, ale dokumenty trzeba dodać przed zamknięciem roku.',
  'clo.purchases.inboxSideHelp': 'Tutaj znajdują się dokumenty, które nie zostały jeszcze zaksięgowane.',
  'clo.purchases.inboxInteractionHint': 'Otwórz dokument, aby go sprawdzić.',
  'clo.purchases.continueWithoutInbox': 'Kontynuuj bez obsługi',
  'clo.purchases.continueConfirmTitle': 'Nieistotne dla zamknięcia roku?',
  'clo.purchases.continueConfirmText': 'Potwierdź, że nieobsłużone dokumenty (liczba: {{count}}) nie są istotne dla kontroli zakupów za {{year}}. Pozostaną w skrzynce odbiorczej, ale nie zablokują tego zamknięcia roku.',
  'clo.purchases.inboxExcluded': 'Dokumenty zostały ocenione jako nieistotne dla tego zamknięcia roku.',
  'clo.purchases.excludeError': 'Nie udało się zapisać oceny.',
  'clo.purchases.noPurchaseIssues': 'Brak otwartych rozbieżności w zarejestrowanych zakupach.',
  'clo.purchases.missingDocumentation': 'Brak dokumentu',
  'clo.purchases.lostDocumentation': 'Zgłoszono utratę dokumentu. Rozbieżność została zarejestrowana, ale zakup nadal wymaga dokumentacji.',
  'clo.purchases.draft': 'Szkic zakupu wymaga dokończenia',
  'clo.purchases.undated': 'Brak prawidłowej daty. Ustal, do którego roku należy pozycja.',
  'clo.purchases.unknownDate': 'Brak prawidłowej daty',
  'clo.purchases.inboxTitle': 'Nieobsłużone dokumenty ({{count}})',
  'clo.purchases.inboxScope': 'Obsłuż dokumenty należące do {{year}} lub kontynuuj, jeśli nie są istotne dla tego zamknięcia roku.',
  'clo.purchases.scopeHelp': 'Niezapłacona faktura od dostawcy może być w pełni zaksięgowana. Płatność, uzgodnienie VAT i rozgraniczenie okresów są sprawdzane w osobnych krokach. Gotowe oznacza tutaj, że zarejestrowane zakupy i skrzynka odbiorcza przeszły tę kontrolę.',
  'clo.purchases.openPurchase': 'Otwórz zakup',
  'clo.purchases.openInbox': 'Obsłuż dokumenty w skrzynce odbiorczej',
  'clo.purchases.back': 'Wróć do kontroli zakupów',
  'clo.purchases.backToClosing': 'Wróć do zamknięcia roku',
  'clo.purchases.loadError': 'Nie udało się otworzyć obszaru zakupów.',
  'clo.payables.title': 'Zobowiązania wobec dostawców',
  'clo.payables.itemsTitle': 'Otwarte pozycje dostawców na dzień 31.12.{{year}}',
  'clo.payables.itemsHelp': 'Faktury od dostawców otwarte na przełomie roku, także z lat wcześniejszych. Późniejsze płatności są pokazywane osobno i nie zmieniają salda na dzień 31.12.',
  'clo.payables.supplier': 'Dostawca i dokument',
  'clo.payables.date': 'Data dokumentu i termin płatności',
  'clo.payables.openAmount': 'Otwarte na przełomie roku',
  'clo.payables.followUp': 'Działania następcze',
  'clo.payables.paidAfterAmount': 'Zapłacono po przełomie roku: {{amount}}',
  'clo.payables.balanceTitle': 'Uzgodnienie z księgą główną',
  'clo.payables.assessmentTitle': 'Ocena i zatwierdzenie',
  'clo.payables.reviewHelp': 'Oceń pozycje za pomocą pól wyboru w tabeli przed zatwierdzeniem kontroli.',
  'clo.payables.saveAssessment': 'Zapisz ocenę',
  'clo.payables.help': 'Księga główna i otwarte pozycje dostawców na dzień 31.12.{{year}} są porównywane automatycznie.',
  'clo.payables.ledger': 'Księga główna',
  'clo.payables.subledger': 'Rozrachunki',
  'clo.payables.difference': 'Różnica',
  'clo.payables.needsReview': 'Do oceny ({{count}})',
  'clo.payables.allOpen': 'Wszystkie otwarte pozycje ({{count}})',
  'clo.payables.due': 'Termin {{date}}',
  'clo.payables.noDueDate': 'Brak terminu płatności',
  'clo.payables.open': 'Otwórz transakcję',
  'clo.payables.reviewed': 'Ocenione',
  'clo.payables.noRows': 'Brak otwartych pozycji w tym wyborze.',
  'clo.payables.cutOffQuestion': 'Czy są towary lub usługi otrzymane przed 31.12.{{year}}, które nie zostały jeszcze zaksięgowane?',
  'clo.payables.cutOffHelp': 'To część, której Plumme nie może rozstrzygnąć wyłącznie na podstawie zaksięgowanych danych.',
  'clo.payables.cutOffNo': 'Nie, wszystko jest zaksięgowane',
  'clo.payables.cutOffYes': 'Tak, czegoś brakuje',
  'clo.payables.unrecordedHelp': 'Zarejestruj brakujące zakupy, zanim będzie można zakończyć kontrolę.',
  'clo.payables.complete': 'Zatwierdź kontrolę',
  'clo.payables.saved': 'Zobowiązania wobec dostawców zostały sprawdzone.',
  'clo.payables.saveError': 'Nie udało się zapisać kontroli.',
  'clo.payables.reason.reconciled': 'Uzgodnione',
  'clo.payables.reason.notApplicable': 'Brak zobowiązań wobec dostawców na koniec roku.',
  'clo.payables.reason.unsupported': 'Kontrola nie jest obsługiwana dla tego kraju, przepisów lub roku.',
  'clo.payables.reason.stale': 'Dane liczbowe uległy zmianie. Sprawdź pozycje ponownie.',
  'clo.payables.reason.ledgerDifference': 'Księga główna i rozrachunki się nie zgadzają.',
  'clo.payables.reason.missingDocument': 'Otwartej pozycji dostawcy brakuje dokumentu.',
  'clo.payables.reason.invalidDate': 'Faktura od dostawcy nie ma prawidłowej daty.',
  'clo.payables.reason.basisReviewRequired': 'Podstawa kont wymaga sprawdzenia.',
  'clo.payables.reason.cutOffRequired': 'Jedna informacja wymaga wyjaśnienia.',
  'clo.payables.reason.unrecordedItems': 'Brakujące zakupy muszą zostać zaksięgowane.',
  'clo.payables.reason.exceptionsRequired': 'Oceń oznaczone pozycje.',
  'clo.payables.reason.reviewRequired': 'Kontrolę trzeba zakończyć.',
  'clo.payables.issue.ledgerDifference': 'Różnicę trzeba poprawić w księgowości, zanim będzie można zakończyć kontrolę.',
  'clo.payables.issue.missingDocument': 'Dodaj dokumenty do otwartych pozycji, którym brakuje dokumentacji.',
  'clo.payables.issue.invalidDate': 'Otwórz fakturę od dostawcy i wprowadź prawidłową datę faktury.',
  'clo.payables.issue.basisReviewRequired': 'Plumme nie może obliczyć wiarygodnej podstawy kont dla tej firmy.',
  'clo.payables.flag.old': 'Starsze niż 90 dni',
  'clo.payables.flag.overdue': 'Przeterminowane ponad 30 dni',
  'clo.payables.flag.negative': 'Saldo ujemne',
  'clo.payables.flag.duplicate': 'Możliwy duplikat',
  'clo.payables.flag.currency': 'Pozycja walutowa',
  'clo.payables.flag.missingDocument': 'Brak dokumentu',
  'clo.payables.flag.paidAfter': 'Zapłacono po końcu roku',
});
